export const SIGNUP_URL = 'https://api.ometria.com/overlays/signup';
